import React from 'react';

export const Price = ({
  price,
  priceYearlyOriginal,
  isSelectedBillingFrequencyYearly,
}: {
  price: number | undefined;
  priceYearlyOriginal: number | undefined;
  isSelectedBillingFrequencyYearly: boolean;
}) => {
  return (
    <div className='inline-flex w-full justify-between items-center font-sans font-normal mb-5 text-customBlack'>
      <span>
        <span className='text-7xxl'>
          <sup style={{ fontSize: '60%' }}>$</sup>
          <span>{price}</span>
        </span>
        <span className='text-4xl'>
          /{isSelectedBillingFrequencyYearly ? 'YEAR' : 'MONTH'}
        </span>
      </span>

      {isSelectedBillingFrequencyYearly && !!priceYearlyOriginal && (
        <span className='text-customLightGrey text-5xl mt-7'>
          <sup style={{ fontSize: '60%' }}>$</sup>
          <del>{priceYearlyOriginal}</del>
        </span>
      )}
    </div>
  );
};
